exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".notifications .alert{position:fixed;z-index:100}.notifications .alert[data-notify=container]{width:400px}.notifications .alert.center{left:0;right:0;margin:0 auto}.notifications .alert.left{left:20px}.notifications .alert.right{right:20px}", ""]);

